import React from 'react';

import {Carousel} from 'antd';

import {HomeBannerConfig} from '../configs';

import icon1 from '../assets/icon/home-icon1.png';
import icon2 from '../assets/icon/home-icon2.png';
import icon5 from '../assets/icon/home-icon5.png';
import icon6 from '../assets/icon/home-icon6.png';
import icon7 from '../assets/icon/home-icon7.png';
import icon8 from '../assets/icon/home-icon8.png';
import icon9 from '../assets/icon/home-icon9.png';
import icon10 from '../assets/icon/home-icon10.png';

import img1 from '../assets/imgs/home-img1-1.png';
import img2 from '../assets/imgs/home-img2.png';
import img3 from '../assets/imgs/home-img3.png';
import img4 from '../assets/imgs/home-img4.png';

import './index.scss';

const bannerContentStyle = {
    heigh: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '18px',
};

export default function Home() {
    return (
        <div id="pc">
            <div className="main-1 flex items-center px-[4vw] relative">
                <div className="left-box flex items-center h-full z-20">
                    <Carousel
                        autoplay
                        style={{width: '41.6vw', minWidth: '320px'}}
                        dots={{className: 'circle'}}
                    >
                        {HomeBannerConfig.map(item => (
                            <div>
                                <div style={bannerContentStyle}>
                                    <div className="wrapper-1 flex items-center pl-[4px] relative">
                                        <img
                                            src={icon1}
                                            alt="icon1"
                                            className="w-[24px] h-[24px]"
                                        />
                                        <span>外壳伪装 禁止截屏</span>
                                        <img
                                            src={icon2}
                                            alt="icon2"
                                            className="w-[32px] h-[32px] absolute top-[-16px] right-[-16px]"
                                        />
                                    </div>

                                    <div className="wrapper-2 text-[36px] text-[#091d5a] font-medium">
                                        {item.title}
                                    </div>

                                    <span className="wrapper-3 text-[12px] text-[#091d5a]">
                                        {item.text}
                                    </span>

                                    <div className="flex gap-[1vw]">
                                        <img
                                            className="w-[128px] h-[128px]"
                                            src={item.android_qrc}
                                            alt="二维码"
                                        ></img>
                                        <img
                                            className="w-[128px] h-[128px]"
                                            src={item.apple_qrc}
                                            alt="二维码"
                                        ></img>
                                    </div>

                                    <div className="wrapper-5 flex gap-[12px]">
                                        <a
                                            data-v-233438f9=""
                                            href={item.download_android}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="btn">
                                                <i className="icon3 w-[24px] h-[24px]" />

                                                <div>
                                                    <span className="text-[12px]">
                                                        安卓下载
                                                    </span>
                                                    <p className="font-medium">
                                                        Android
                                                    </p>
                                                </div>
                                            </div>
                                        </a>

                                        <a
                                            data-v-233438f9=""
                                            href={item.download_apple}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <div className="btn">
                                                <i className="icon4 w-[24px] h-[24px]" />

                                                <div>
                                                    <span className="text-[12px]">
                                                        苹果下载
                                                    </span>
                                                    <p className="font-medium">
                                                        App Store
                                                    </p>
                                                </div>
                                            </div>
                                        </a>
                                    </div>

                                    <span className="wrapper-6 text-[12px] text-[#FF3F3F]">
                                        {item.tips}
                                    </span>
                                </div>
                            </div>
                        ))}
                    </Carousel>
                </div>
                <div className="right-box absolute right-[36px] z-10 max-md:opacity-30">
                    <img
                        src={img1}
                        alt="img1"
                        className="w-[525px] h-[auto] min-w-[180px] min-h-[180px]"
                    />
                    <div className="tips top-[60px] right-0">
                        <img src={icon1} alt="icon1" />
                        <span>读后清除 双向删除</span>
                    </div>
                    <div className="tips top-[180px] left-[-100px]">
                        <img src={icon1} alt="icon1" />

                        <span>图文音视频畅聊</span>
                    </div>
                    <div className="tips tips-3  bottom-[20px] right-[120px]">
                        <img src={icon1} alt="icon1" />
                        <span>智能返回 私密相册</span>
                    </div>
                </div>
            </div>

            <div className="main-2 text-center py-[22px]">
                <h1 className="text-[36px] font-semibold text-[#292929]">
                    防查岗、防窥视的安全聊天
                </h1>
                <p className="text-[14px] text-[#292929] mt-[8px]">
                    聊天信息安全隐秘，有效防止信息泄露，安全稳定畅所欲言。保护个人隐私安全。
                </p>

                <div className="photo-container flex justify-center flex-wrap gap-[20px] mt-[32px]">
                    <div className="photo-box">
                        <img src={img2} alt="img" />
                        <p>外壳伪装</p>
                        <span>
                            拥有天气、单词、计算器、资讯、翻译、浏览器、百科多种外壳伪装
                        </span>
                    </div>

                    <div className="photo-box">
                        <img src={img3} alt="img" />
                        <p>读后清除</p>
                        <span>消息被阅读后自动销毁，不留痕迹</span>
                    </div>

                    <div className="photo-box">
                        <img src={img4} alt="img" />

                        <p>双向删除</p>
                        <span>删除双方聊天记录，彻底消失+隐私清零</span>
                    </div>
                </div>
            </div>

            <div className="main-3 text-center py-[22px]">
                <h1 className="text-[36px] font-semibold text-[#292929]">
                    多样化实用功能
                </h1>
                <p className="text-[14px] text-[#292929] mt-[8px]">
                    和TA在这联系，更安全、隐秘和便捷
                </p>

                <div className="photo-container px-[120px] flex justify-center gap-[18px] mt-[32px] flex-wrap">
                    <div className="photo-box">
                        <img src={icon5} alt="img" />
                        <p>音视频畅聊</p>
                        <span>
                            文字、语音、图片、视频、文件、音视频通话、表情等多种聊天方式
                        </span>
                    </div>

                    <div className="photo-box">
                        <img src={icon6} alt="img" />
                        <p>智能返回</p>
                        <span>
                            遇到突发状况：点击或翻转手机，立即智能切换至伪装界面，守护您的隐私安全
                        </span>
                    </div>

                    <div className="photo-box">
                        <img src={icon7} alt="img" />

                        <p>禁止截屏</p>
                        <span>对方无法截屏聊天界面</span>
                    </div>

                    <div className="photo-box">
                        <img src={icon8} alt="img" />

                        <p>隐藏个人信息</p>
                        <span>隐藏个人账号信息TA人无法查看</span>
                    </div>

                    <div className="photo-box">
                        <img src={icon9} alt="img" />

                        <p>私密相册</p>
                        <span>私密相册无限珍藏，还能把照片共享给亲密好友</span>
                    </div>

                    <div className="photo-box">
                        <img src={icon10} alt="img" />

                        <p>保密时段</p>
                        <span>多重密码防护，安全隐私保护</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
